import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { opuPaths } from '../../opu/queries/paths';
import { deletionPaths } from '../queries/paths';

// TSS vite/03 — eliminaciones sensibles (auditoría). Borrado en cascada de sesiones OPU
// (admin-aspiration-sessions.md · 0127). El listado ya trae `counts` (aspirations/clivages/
// embryos/transfers/pregnancies/births) → sirve de preview de la cascada sin fetch extra.

// Buscador de sesiones OPU por código (q). enabled sólo con ≥2 caracteres.
export function useOpuSearch(q) {
    const term = (q || '').trim();
    return useQuery({
        queryKey: ['audit', 'opu-search', term],
        queryFn:  ({ signal }) => api.get(opuPaths.list(), { params: { q: term, limit: 15 }, signal }).then(r => r.data),
        enabled:  term.length >= 2,
        placeholderData: (prev) => prev,
    });
}

// Borrado en cascada (soft-delete, all-or-nothing). Requiere confirm:true. Devuelve la sesión
// con status=0 + cascade.counts. Invalida OPU y toda la descendencia afectada.
export function useDeleteOpuSession() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(deletionPaths.opuSession(id), { data: { confirm: true } }).then(r => r.data),
        onSuccess: () => {
            ['opu', 'aspiration-sessions', 'clivages', 'embryos', 'transfers', 'pregnancies', 'animals', 'recipients', 'asocebu']
                .forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
        },
    });
}
